import * as React from "react";
import {GAMES} from "./constants";
import {
  Panel,
  PanelHeader,
  Title,
  View,
  Div,
  Header,
  Group,
  List,
  Text,
  SimpleCell,
  Avatar,
  Link,
  Paragraph
} from "@vkontakte/vkui";
import { Icon24ExternalLinkOutline } from "@vkontakte/icons";


class GameList extends React.Component {
  setGame = (event) => {
    let type = event.currentTarget.dataset.type;
    let item = GAMES[type].sections.reduce((val, section) => {
      return val.length > 0 ? val : section.items.filter(item => item.slug === event.currentTarget.dataset.name);
    }, []);
    this.props.setGame(type, item[0]);
  };

  prepareRecord(slug) {
    if (this.props.records === null) {
      return null;
    }
    let record = this.props.records[`${this.props.id}-${slug}`];
    return (record) ? `Рекорд ${record}` : null;
  }

  render() {
    let game = GAMES[this.props.id];
    return <View activePanel={this.props.id} id={this.props.id}>
      <Panel id={this.props.id}>
        <PanelHeader>GeoPuzzle</PanelHeader>
        <div style={{fontSize: "large", textAlign: "center", background: "bisque"}}>
          <Paragraph>Полная версия на </Paragraph>
          <Link href="https://geopuzzle.org" target="_blank">
             https://geopuzzle.org
            <Icon24ExternalLinkOutline width={16} height={16} /></Link>
        </div>
        <Div>
          <Title weight="1" style={{marginBottom: 16}} level="1">{game.title}</Title>
          <Text weight="3">{game.text}</Text>
        </Div>
        <List>
          {game.sections.map(category =>
            <Group header={<Header mode="secondary">{category.title}</Header>} key={category.title}>
              <List>
                {category.items.map(cell =>
                  <SimpleCell
                    after={<img src={`https://d2nepmml5nn7q0.cloudfront.net/vkminiapp/icons/${cell.difficult}.png`} />}
                    onClick={this.setGame}
                    before={<Avatar size={48} src={`https://d2nepmml5nn7q0.cloudfront.net/vkminiapp/${cell.slug}-flag-round-icon-64.png`}/>}
                    description={this.prepareRecord(cell.slug)}
                    data-type={this.props.id}
                    data-name={cell.slug} key={cell.slug}>
                    {cell.title}
                  </SimpleCell>
                )}
              </List>
            </Group>
          )}
        </List>
      </Panel>
    </View>;
  }
}

export default GameList;
